export function getAll() {
  return [
    {
      value: 0,
      name: "Discount",
      text: "折扣",
    },
    {
      value: 1,
      name: "FreePrice",
      text: "折讓",
    },
    {
      value: 2,
      name: "RedeemItem",
      text: "加價兌換",
    },
    {
      value: 3,
      name: "PointRedeemItem",
      text: "點數兌換",
    },
  ];
}

export function getForSearch() {
  return [
    { value: -1, name: "All", text: "全部" },
    { value: 0, name: "Discount", text: "折扣" },
    { value: 1, name: "FreePrice", text: "折讓" },
    { value: 2, name: "RedeemItem", text: "加價兌換" },
    { value: 3, name: "PointRedeemItem", text: "點數兌換" },
    { value: 4, name: "DiscountAndFreePrice", text: "折扣&折讓" },
    { value: 5, name: "DiscountAndRedeemItem", text: "折扣&加價兌換" },
    { value: 6, name: "DiscountAndPointRedeemItem", text: "折扣&點數兌換" },
    { value: 7, name: "FreePriceAndRedeemItem", text: "折讓&加價兌換" },
    { value: 8, name: "FreePriceAndPointRedeemItem", text: "折讓&點數兌換" },
    {
      value: 9,
      name: "RedeemItemAndPointRedeemItem",
      text: "加價兌換&點數兌換",
    },

    {
      value: 10,
      name: "DiscountAndFreePriceAndRedeemItem",
      text: "折扣&折讓&加價兌換",
    },
    {
      value: 11,
      name: "DiscountAndFreePriceAndPointRedeemItem",
      text: "折扣&折讓&點數兌換",
    },
    {
      value: 12,
      name: "DiscountAndRedeemItemAndPointRedeemItem",
      text: "折扣&加價兌換&點數兌換",
    },
    {
      value: 13,
      name: "FreePriceAndRedeemItemAndPointRedeemItem",
      text: "折讓&加價兌換&點數兌換",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
